// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"887":"2a5a2c6c09359cc41cbd","940":"3c96e1f3ea23aa383e77"}[chunkId] + ".js";
};